import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Department } from '../../models/department';
import { DepartmentService } from '../../services/department.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { EmployeeService } from '../../services/employee.service';
import { VenueMaster } from '../../models/venuemaster';
import { VenueMasterService } from '../../services/venuemaster.service';
import { CommitteeService } from '../../services/committee.service';
import { DatePipe } from '@angular/common';
import { BasicMasterService } from '../../services/basicmaster.service';
import { BasicMaster } from '../../models/basicmaster';
import { FacilityManager } from '../../models/facilitymanager';
import { FacilityManagerService } from '../../services/facilitymanager.service'; 
@Component({
  selector: 'app-venue',
  templateUrl: './venue.component.html',
  styleUrls: ['./venue.component.css']
})
export class VenueComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerVenue: PageHeader;
  entity: VenueMaster = new VenueMaster();
  selectedVenue: VenueMaster = new VenueMaster();
  editingEntity: VenueMaster = new VenueMaster();
  Venue: any;
  VenueColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  locations: Array<Location> = [];
  selectedLocation: any;
  _selectedVenue: any;
  basicmaster: Array<BasicMaster> = [];
  selectedEmployee: any;
  selectedvenue: any;
  selectedFacilitymanger: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  departments: Array<Department> = [];
  pipe = new DatePipe('en-US');
  facilitymanagers: any;
  opened: boolean = false;
  details: any;
  constructor(
    private _departmentService: DepartmentService,
    private _basicMasterService: BasicMasterService,
    private _VenueService: VenueMasterService,
    private _committeeService: CommitteeService,
    private _locationService: LocationService,
    private _employeeService: EmployeeService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private _facilitymanagerService: FacilityManagerService,  
  ) {
    this.headerVenue = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.Venue = [];
    this.getAllVenue();
  }
  ngAfterViewInit(): void {
    this.VenueColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },
      { field: "VenueName", title: 'Venue', filter: true, sortable: true, width: 150 },
      { field: "VenueAddress", title: 'Address ', filter: true, sortable: true, width: 150 },
      { field: "VenuetypeName", title: 'Venue Type ', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];

  }

  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._VenueService.getAllVenue('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<VenueMaster>) => {
      this.Venue = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }


  // onPaginationChange(event: any) {
  //   if (this.defaultPageSize != event.take) {
  //     this.defaultPageSize = event.take;
  //   }
  //   this.pageSkip = event.skip;
  //   this._VenueService.getAllVenue('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0,0).subscribe((entities: Array<VenueMaster>) => {
  //     this.Venue = {
  //       data: entities,
  //       total: entities[0] ? entities[0].TotalCount : 0
  //     }
  //   });
  // }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._VenueService.getAllVenue(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((Venue: Array<VenueMaster>) => {
        this.Venue = {
          data: Venue,
          total: Venue[0] ? Venue[0].TotalCount : 0
        }
      });
    }
  }
  getAllVenue() {
    this._VenueService.getAllVenue('', Number(this.defaultPageSize), 1, 0, 0).subscribe((Venue: Array<VenueMaster>) => {
      this.Venue.DateOfFormation = new Date(this.Venue.DateOfFormation);
      this.Venue = Venue;
      for (let i = 0; i < Venue.length; i++) {
        this.Venue[i].DateOfFormation = this.pipe.transform(this.Venue[i].DateOfFormation, "dd/MM/yyyy");
      }
      this.Venue = {
        data: Venue,
        total: Venue[0] ? Venue[0].TotalCount : 0
      }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._VenueService.deleteVenue(this.selectedVenue.Venue_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearVenue();
            this.getAllVenue();
          },
          )
        }
      }
    });
  }
  getAllVenue_type(filter: string) {
    this._basicMasterService.getBasicMastersByName('VenueType', filter, this.defaultRowsCount, 1).subscribe((data: Array<BasicMaster>) => {
      this.basicmaster = data;
    })
  }

  getAllFacilityManagers(filter: string) {
    this._facilitymanagerService.getAllFacilityManager('', Number(this.defaultPageSize), 1, 0,1).subscribe((facilitymanagers: Array<FacilityManager>) => {
      this.facilitymanagers = facilitymanagers;
    });
  }
  initPageHeader(): PageHeader {
    let headerVenue = new PageHeader();
    headerVenue.PageCaption = "Venue ";
    headerVenue.IconClass = "bi bi-shield-shaded";
    return headerVenue;
  }

  deleteVenue(event: any) {
    if (event.seletedRows[0]) {
      this.selectedVenue.Venue_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Venue",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addVenue(event: any) {
    this.listView = false;
    this.clearVenue();
    this.getAllVenue_type('');
    this.getAllFacilityManagers('');
    this.formCaption = "Add Venue ";
  }

  editVenue(event: any): void {
    if (event.seletedRows[0]) {
      this._VenueService.viewVenue(event.seletedRows[0]).subscribe((Venue: Array<VenueMaster>) => {
        let editEnity = Venue[0] ? Venue[0] : new this.Venue();

        if (editEnity) {
          this.selectedvenue = { DisplayValue: editEnity.Venuetype_Id, DisplayText: editEnity.VenuetypeName };
          this.selectedFacilitymanger = { FacilityManager_Id: editEnity.FacilityManager_Id, FacilityManagerName: editEnity.FacilityManagerName };
          
          this.editingEntity = editEnity;
          this.entity = { ...this.editingEntity };
          //this._selectedVenue= {DateOfFormation: new Date(this.editingEntity.DateOfFormation)};
          this.getAllVenue_type('');
          this.getAllFacilityManagers('');
          this.listView = false;
          this.formCaption = "Edit Venue";

          this.entity.EntityMetaData = [
            { FieldName: 'VenueName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Venue Name is required' },
            { FieldName: 'VenueAddress', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Address is required' },
            { FieldName: 'Venuetype_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Venue Type is required' }
          ];
        }
      });
    }
  }

  save(event: any): void {
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._VenueService.checkDuplication(this.entity.VenueName, this.entity.Venue_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Venue already exists');
          this.saveDisabled = false;
        }
        else {
          if (this.entity.Phone.length != 0 && this.entity.Phone.length != 10) {
            this.notification.showWarning("Invalid Phone No.");
            this.saveDisabled = false;
          }
          else {
            this._VenueService.saveVenue(this.entity).subscribe(() => {
              if (this.entity.Venue_Id == "00000000-0000-0000-0000-000000000000") {
                this.notification.showSuccess('Saved Successfully');
              }
              else {
                this.notification.showSuccess('Updated Successfully');
              }
              this.listView = true;
              this.clearVenue();
              this.getAllVenue();
            })
          }
        }
      });
    }
    else {
      this.saveDisabled = false;
    }
  }
  goToBackTab(): void {

    this.listView = true;

  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
 gotoBack(): void {
    this.listView = true;
    this.getAllVenue();
  }

  refreshDepartments(event: any): void {
    this.Venue = [];
    this.getAllVenue();
  }

  clearVenue(): void {
    this._selectedVenue = {};
    this.entity = new VenueMaster();
    this.saveDisabled = false;
    this.selectedvenue ={};
    this.selectedFacilitymanger={};
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Venue_Id = dataItem.Venue_Id;
    this.details = [];
    this._VenueService.viewVenue(this.entity.Venue_Id).subscribe((Venue: Array<VenueMaster>) => {
      this.opened = true;
      this.details = Venue[0];
    })}
}

